module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.c5f336de.svg";